import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

declare var dataLayer: any[];

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {
    this.initGtm();
    this.trackRouteChanges();
  }

  private initGtm() {
    if (isPlatformBrowser(this.platformId) && environment.gtmId) {
      // Asegurar que dataLayer exista inmediatamente
      (window as any).dataLayer = (window as any).dataLayer || [];

      // 1. Inyectar script en el head
      const script = document.createElement('script');
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${environment.gtmId}');
      `;
      document.head.appendChild(script);

      // 2. Inyectar noscript en el body (Fallback para navegadores sin JS)
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/gtm.ns.html?id=${environment.gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }

  /**
   * Envía un evento personalizado a GTM/GA4
   * @param eventName Nombre del evento (ej: 'whatsapp_click')
   * @param params Parámetros adicionales
   */
  trackEvent(eventName: string, params: any = {}) {
    if (isPlatformBrowser(this.platformId)) {
      const dl = (window as any).dataLayer || [];
      dl.push({
        event: eventName,
        ...params
      });
    }
  }

  /**
   * Track de clic en WhatsApp
   */
  trackWhatsAppClick(location: string) {
    this.trackEvent('whatsapp_click', {
      click_location: location
    });
  }

  /**
   * Track de visualización de noticia
   */
  trackNewsView(newsId: number, newsTitle: string) {
    this.trackEvent('news_view', {
      news_id: newsId,
      news_title: newsTitle
    });
  }

  /**
   * Escucha los cambios de ruta para enviar un evento de page_view virtual
   */
  private trackRouteChanges() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: any) => {
        this.trackEvent('page_view', {
          page_path: event.urlAfterRedirects,
          page_title: document.title,
          page_location: window.location.href
        });
      });
    }
  }
}
